module.exports = __webpack_public_path__ + "img/the sun evolution 1-01.517bb6a9.png";